
import {Vue, Component, Prop} from "vue-property-decorator";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import { ListDataSource } from "@/data/List/ListDataSource";
import { Filter } from "@/cms-services/filter";
import stringEditor from "@/components/common/inline-editor/string.vue";
import htmlEditor from "@/components/common/inline-editor/html.vue";
import draggable from "vuedraggable";
import ObjectExpansionEditor from "@/components/helpers/object-expansion-editor.vue";
import moment from "moment/moment";
import {
  mdiAutorenew,
  mdiDotsVertical,
  mdiFolder,
  mdiFolderOpen,
  mdiMagnify,
  mdiPen,
  mdiPlusCircleOutline,
  mdiTrashCan
} from "@mdi/js";

@Component({
  components: { stringEditor, draggable, htmlEditor, ObjectExpansionEditor },
})
export default class Home extends Vue {
  @Prop({}) propertiesOverrideInfo!: any;
  @Prop({}) propertyGroupsOverrideInfo!: any;

  drawer: boolean = false;
  drawerLoaded: boolean = false;
  editingItemRef: any = null;
  $message: any;
  loading: boolean = false;
  searchQuery: string = "";

  dataSource: ObjectDataSource = new ObjectDataSource({
    id: +this.$route.params.id,
    config: {},
    className: "course",
  });

  courseItemDataSource: ListDataSource = new ListDataSource({
    config: { pageIndex: 1, pageSize: 15 },
    className: "courseItem",
  });

  ungroupedCourseItemDataSource: ListDataSource = new ListDataSource({
    className: "courseItem",
    config: {
      pageIndex: 1,
      pageSize: 50,
      filter: JSON.stringify([
        {
          fieldName: "courseId",
          fieldValue: +this.$route.params.id,
        },
        {
          fieldName: "courseItemGroupId",
          fieldValue: null,
          operation: "Equals"
        },
      ]),
    },
  });

  courseItemGroupDataSource: ListDataSource = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 15,
      filter: JSON.stringify([new Filter("courseId", +this.$route.params.id)])
    },
    className: "courseItemGroup",
  });



  editorDataSource: ObjectDataSource = new ObjectDataSource({
    id: 0,
    config: {},
    className: "",
  });

  createItemModel: any = {
    courseId: +this.$route.params.id,
    caption: "",
  };

  icons: any = {
    pen: mdiPen,
    trash: mdiTrashCan,
    search: mdiMagnify,
    dotsVertical: mdiDotsVertical,
    circlePlus: mdiPlusCircleOutline,
    folderOpen: mdiFolderOpen,
    folder: mdiFolder,
    refresh: mdiAutorenew,
  };


  get caption() {
    return this.dataSource.model?.caption;
  }

  get groups() {
    return [...(this.dataSource.model.courseItemGroups || [])].sort((a: any, b: any) =>
        (a.priority || 0) - (b.priority || 0)
    );
  }

  get breadcrumbs() {
    return [
      { text: "Главная", to: "/" },
      { text: "Курсы", to: "/manage/courses/", exact: true },
      { text: this.dataSource.model?.caption, disabled: true },
    ];
  }

  routeToPage(name: string) {
    this.$router.push({
      name,
      params: {
        courseId: this.$route.params.id,
      },
    });
  }
  getObjectDataSource(id: number, className: string, model: any) {
    return new ObjectDataSource({
      id: id,
      model: model,
      config: {},
      className: className,
    });
  }

  async openEditor(item: any, className: string) {
    this.drawerLoaded = false;
    this.drawer = true;
    this.editingItemRef = item;

    this.editorDataSource.id = item.id;
    this.editorDataSource.className = className;
    await this.editorDataSource.get();
    await this.editorDataSource.getMetaData();

    this.drawerLoaded = true;
  }

  closeDrawer() {
    if (this.editingItemRef && this.editorDataSource.model) {
      Object.assign(this.editingItemRef, this.editorDataSource.model);
    }
    this.drawer = false;
    this.editingItemRef = null;
  }
  async onCourseItemChange(event: any, group: any) {
    if (event.added) {
      const item = event.added.element;
      item.courseItemGroupId = group.id;

      // Сразу обновляем ID группы
      this.$set(item, 'courseItemGroupId', group.id);

      // Предварительно выставляем приоритет (на всякий случай, updateItem потом пересчитает точно)
      const newIndex = event.added.newIndex;
      this.$set(item, 'priority', newIndex + 1);
      
      this.updateItem(group);

      this.getObjectDataSource(item.id, 'courseItem', item)
          .updateField({ fieldName: 'courseItemGroupId', fieldValue: group.id })
          .catch(e => {
            console.error("Ошибка при смене группы", e);
            // Тут можно добавить логику отката (вернуть элемент назад), если сервер упал
          });
    }
    if (event.moved || event.removed) {
      this.updateItem(group);
    }
  }

  async onUngroupedListChange(event: any) {
    if (event.added) {
      const item = event.added.element;
      item.courseItemGroupId = null;

      try {
        await this.getObjectDataSource(item.id, 'courseItem', item)
            .updateField({ fieldName: 'courseItemGroupId', fieldValue: null });
        console.log('Элемент перемещен в "без групп"');
      } catch (e) {
        console.error("Ошибка при обнулении группы", e);
      }
    }
  }

  async createUngroupedItem() {
    const newItem = {
      caption: "Новая лекция (без группы)",
      courseId: this.dataSource.model.id,
      courseItemGroupId: null
    };
    await this.ungroupedCourseItemDataSource.add(newItem, true);
    this.$message("Создана лекция без группы");
  }

  async deleteUngroupedItem(item: any) {
    if (!confirm("Удалить лекцию без группы?")) return;
    await this.ungroupedCourseItemDataSource.remove(item.id);
    this.ungroupedCourseItemDataSource.items.filter(item => item.id !== item.id)
  }

  async onSearch() {
    // Простой пример фильтрации. Вам нужно адаптировать под ваш API фильтр
    const filters = [
      { fieldName: "courseId", fieldValue: +this.$route.params.id },
      { fieldName: "courseItemGroupId", fieldValue: null, operation: "Equals" }
    ];

    if (this.searchQuery) {
      filters.push({
        fieldName: "searchText",
        fieldValue: this.searchQuery,
      } as any);
    }

    this.ungroupedCourseItemDataSource.config.filter = JSON.stringify(filters);
    this.ungroupedCourseItemDataSource.config.pageIndex = 1;
    await this.ungroupedCourseItemDataSource.get();
  }

  async updateGroup() {
    const updatePromises = this.dataSource.model.courseItemGroups.map((group, index) => {

      const updateData = {
        fieldName: 'priority',
        fieldValue: index + 1
      };

      // Получаем dataSource для конкретной группы
      const groupDataSource = this.getObjectDataSource(group.id, 'courseItemGroup', group);

      // Обновляем на сервере
      return groupDataSource.updateField(updateData);
    });

    try {
      await Promise.all(updatePromises);
      console.log('Приоритеты успешно обновлены');
    } catch (err) {
      console.error('Ошибка при обновлении приоритетов:', err);

    }
  }

  async updateItem(group: any) {

    group.courseItems.forEach((item: any, index: number) => {
      this.$set(item, 'priority', index + 1);
    });
    
    const updatePromises = group.courseItems.map((item, index) => {

      // Создаем объект обновления: fieldName: 'priority', fieldValue: index
      const updateData = {
        fieldName: 'priority',
        fieldValue: index + 1
      };

      // Получаем dataSource для конкретной группы
      const groupItemDataSource = this.getObjectDataSource(item.id, 'courseItem', item);

      // Обновляем на сервере
      return groupItemDataSource.updateField(updateData);
    });

    try {
      await Promise.all(updatePromises);
      console.log('Приоритеты успешно обновлены');
    } catch (err) {
      console.error('Ошибка при обновлении приоритетов:', err);

    }
  }

  async addGroup() {
    const newGroup = {
      caption: `Новая группа ${this.dataSource.model.courseItemGroups.length + 1}`,
      courseId: this.dataSource.model.id,
      priority: this.dataSource.model.courseItemGroups.length + 1,
      instanceStateId: 4
    };
    const item = await this.courseItemGroupDataSource.add(newGroup, true);
    this.dataSource.model.courseItemGroups.push(item);
  }

  async removeGroup(group: any) {
    if(group.courseItems.length > 0) {
      this.$message("Группу невозможно удалить!");
      return;
    }
    if (!confirm("Удалить группу?")) return;
    await this.courseItemGroupDataSource.remove(group.id);
    this.dataSource.model.courseItemGroups = this.dataSource.model.courseItemGroups.filter(
        (g: any) => g.id !== group.id
    );
  }

  async addItem(group: any) {
    const newItem = {
      caption: `Новая лекция ${group.courseItems?.length || 0 + 1}`,
      courseItemGroupId: group.id,
      courseId: this.dataSource.model?.id,
      priority: (group.courseItems?.length || 0) + 1,
      instanceStateId: 4
    };
    const item = await this.courseItemDataSource.add(newItem, true);
    if (!group.courseItems) group.courseItems = [];
    group.courseItems.push(item);
  }

  async removeItem(group: any, item: any) {
    if (!confirm("Удалить лекцию?")) return;
    await this.courseItemDataSource.remove(item.id);
    group.courseItems = group.courseItems.filter((i: any) => i.id != item.id);
  }

  async refreshAll() {
    this.loading = true;
    await this.dataSource.get();

    this.loading = false;
    this.$message("Данные успешно обновлены");
  }

  async refreshUngrouped() {
    await this.ungroupedCourseItemDataSource.get();
  }

  getInstanceState(item: any) {
    switch (item.instanceStateId) {
      case 1:
        return 'Создан';
      case 4:
        return 'Активен'
      default:
        return "Создан"
    }
  }
  getInstanceColor(item: any) {
    switch (item.instanceStateId) {
      case 1:
        return 'warning';
      case 4:
        return 'primary';
      default:
        return 'default';
    }
  }
  getDate(item: any){
    return moment(item.createDate).format("DD.MM.YYYY");
  }
  async created() {
    this.ungroupedCourseItemDataSource.get()

    this.editorDataSource.className = this.dataSource.className;
    this.editorDataSource.metadata = this.dataSource.metadata;

    if (this.dataSource.model?.courseItemGroups) {
      this.dataSource.model.courseItemGroups.sort((a: any, b: any) => (a.priority || 0) - (b.priority || 0));


      this.dataSource.model.courseItemGroups.forEach((group: any) => {
        if (group.courseItems) {
          group.courseItems.sort((a: any, b: any) => (a.priority || 0) - (b.priority || 0));
        }
      });
    }
  }
}
